import { DeleteModal } from "@/components/modal/DeleteModal.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import { deleteDiskMutation, type VirtualMachineLoc } from "@/modules/compute/vmQuery.ts";
import { Trans } from "@lingui/react/macro";
import type { VirtualMachineStorage } from "@warrenio/api-spec/spec.oats.gen";

export function DiskDeleteModal({
    vm: { location, uuid },
    disk: { uuid: storage_uuid, primary },
}: {
    vm: VirtualMachineLoc;
    disk: VirtualMachineStorage;
}) {
    const mutation = useStandardMutation(deleteDiskMutation);

    return (
        <DeleteModal
            inTable
            isDisabled={primary}
            modalAction={async () => {
                await mutation.mutateAsync({ location, body: { uuid, storage_uuid } });
            }}
        >
            <DiskDeleteWarning />
        </DeleteModal>
    );
}

export const DiskDeleteWarning = () => (
    <Trans>Deleting the disk will permanently remove it, and it will not be accessible after that.</Trans>
);
